import { combineReducersWithRoot, createReducer } from '@common/redux-utils';
import { CreditCardUpdateModel, SavedCreditCard } from '@models/Account';
import { OptionsViewModel } from '@models/common.models';
import { SimpleAccountViewModel } from '@models/SimpleAccountViewModel';

import {
  ContractPaymentActionType,
  GetAffiliatedAccountsAction,
  GetSavedCreditCardsForContractFailureAction,
  GetSavedCreditCardsForContractStartAction,
  GetSavedCreditCardsForContractSuccessAction,
  SetBillableEntitiesAction
} from './contract-payment.actions';
import {
  ContractPaymentConfirmationReducer,
  ContractPaymentConfirmationState,
  initialContractPaymentConfirmationState
} from './_components/confirmation/contract-payment-confirmation.reducer';

export interface ContractPaymentState {
  affiliatedAccounts?: OptionsViewModel[];
  billableEntities: SimpleAccountViewModel[];
  confirmation: ContractPaymentConfirmationState;
  newCreditCardBalance?: CreditCardUpdateModel;
  newCreditCardInitial?: CreditCardUpdateModel;
  savedCreditCards?: SavedCreditCard[];
}

export const initialContractPaymentState: ContractPaymentState = {
  confirmation: initialContractPaymentConfirmationState,
  billableEntities: []
};

function handleGetAffiliatedAccounts(state: ContractPaymentState, action: GetAffiliatedAccountsAction) {
  return {
    ...state,
    affiliatedAccounts: action.affiliatedAccounts
  };
}

function handleGetSavedCreditCardsForContractFailure(
  state: ContractPaymentState,
  action: GetSavedCreditCardsForContractFailureAction
) {
  return state;
}

function handleGetSavedCreditCardsForContractStart(
  state: ContractPaymentState,
  action: GetSavedCreditCardsForContractStartAction
) {
  return state;
}

function handleGetSavedCreditCardsForContractSuccess(
  state: ContractPaymentState,
  action: GetSavedCreditCardsForContractSuccessAction
) {
  return {
    ...state,
    savedCreditCards: action.savedCreditCards
  };
}

function handleSetBillableEntities(
  state: ContractPaymentState,
  action: SetBillableEntitiesAction
): ContractPaymentState {
  return {
    ...state,
    billableEntities: action.entities
  };
}
function handleSetNewCreditCard(state: ContractPaymentState, action: SetBillableEntitiesAction): ContractPaymentState {
  return {
    ...state
  };
}

const reducer = createReducer<ContractPaymentState, ContractPaymentActionType>(initialContractPaymentState, {
  [ContractPaymentActionType.GetAffiliatedAccounts]: handleGetAffiliatedAccounts,
  [ContractPaymentActionType.GetSavedCreditCardsForContractFailure]: handleGetSavedCreditCardsForContractFailure,
  [ContractPaymentActionType.GetSavedCreditCardsForContractStart]: handleGetSavedCreditCardsForContractStart,
  [ContractPaymentActionType.GetSavedCreditCardsForContractSuccess]: handleGetSavedCreditCardsForContractSuccess,
  [ContractPaymentActionType.SetBillableEntities]: handleSetBillableEntities,
  [ContractPaymentActionType.SetNewCreditCard]: handleSetNewCreditCard
});

export const ContractPaymentReducer = combineReducersWithRoot(reducer, {
  confirmation: ContractPaymentConfirmationReducer
});



// WEBPACK FOOTER //
// ./src/contract/_components/contract-payment/contract-payment.reducer.ts